module.exports = __webpack_public_path__ + "img/4.7883b999.gif";